import { twJoin } from "cn";

export interface SeriesRowBadgeProps {
    letter: string;
    swatchClassName: string;
    size?: "md" | "sm";
}

// intent-ui-deviation: a raw decorative <span> over the vendored Badge (@/components/ui/badge) — Badge takes its hue
export function SeriesRowBadge({ letter, swatchClassName, size = "md" }: SeriesRowBadgeProps) {
    return (
        <span aria-hidden="true" className={twJoin("flex w-7 shrink-0 items-center justify-center rounded-lg text-xs font-bold text-white", size === "sm" ? "h-7" : "h-9", swatchClassName)}>
            {letter}
        </span>
    );
}
